module.exports = __webpack_public_path__ + "img/monitorbox20.0129d749.jpg";